import useUserTableColumns from './useUserTableColumns'

export default useUserTableColumns
